import { Body1 } from "@fluentui/react-components";
import { ArrowForwardDownLightning24Filled, Live24Filled } from "@fluentui/react-icons";
import { useDetailsStyles } from "./details.styles";
import React from "react";

const COLOR_BLUE = "#0F6CBD";

const Details = () => {
  const styles = useDetailsStyles();

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.detailsCard}>
        <div>
          <Live24Filled color={COLOR_BLUE} />
        </div>
        <Body1>Streamline Excel Quote distribution for enhanced Stream Scanner functionality.</Body1>
      </div>

      <div className={styles.detailsCard}>
        <div>
          <ArrowForwardDownLightning24Filled color={COLOR_BLUE} />
        </div>
        <Body1>Precision Price Control for Your Live Streams.</Body1>
      </div>
    </div>
  );
};

export default Details;
